import { useScreenViewTracking } from '../hooks/useScreenViewTracking'
import { useFocusTracking } from '../hooks/useFocusTracking'

/**
 * Mounted once in the app shell. Drives soft-nav `page_view` and tab focus/hide
 * session events. Renders nothing.
 */
export const SessionTracking = () => {
    useScreenViewTracking()
    useFocusTracking()

    return null
}
